import { render } from "./AboutModal.vue?vue&type=template&id=37e462d8&scoped=true&ts=true"
import script from "./AboutModal.vue?vue&type=script&lang=ts"
export * from "./AboutModal.vue?vue&type=script&lang=ts"

import "./AboutModal.vue?vue&type=style&index=0&id=37e462d8&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e462d8"]])

export default __exports__